export default [
  "en",
  "de",
  "fr",
  "es",
  "ja",
  "ko",
  "pt",
  "it",
  "ar",
  "ru",
  "nl"
];
